<template>
  <div class="Home__main-container">
    <div class="Home__header-sub">
      <div class="Home__header-container">
        <div class="Home__header-inner-container">
          <div class="Home__header-info">
            <div class="Home__header-info-item">
              <i class="icon-ic_link Home__header-icon-link"></i>
              {{user.conferenceUrl}}
            </div>
            <div class="Home__header-info-item">
              <i class="icon-ic_lock Home__header-icon-lock"></i>
              PIN {{user.conferencePin}}
            </div>
          </div>
          <div class="Home__header-actions">
            <div class="Home__header-action"
                 :class="copyInfoClass"
                 @click="copyInfo">
              <input type="text" class="hidden" v-model="user.conferenceUrl" id="conference_url"/>
              <span class="Home__header-action--tranquil">copy info</span>
              <i class="icon-ic_spinner Home__header-action--processing"></i>
              <span class="Home__header-action--termination">copied</span>
            </div>
            <div class="Home__header-action"
                 :class="{'active': subscription.active}"
                 @click="toggleUpgradeMenu">
              {{ subscription.active ? 'upgraded' : 'upgrade' }}
            </div>
            <upgrade-dropdown
            :is-open.sync="showUpgradeMenu">
            </upgrade-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="Home__body">
      <div class="Home__body-container">
        <div class="Home__title">
          Welcome to Your Conference Room
        </div>
        <img class="Home__logo-icon"
             src="../../../../static/images/logo-icon.png"/>
        <div class="Home__main-actions">
          <a @click="joinOwnRoom"
            class="Home__main-action-btn Home__main-action-btn--blue">
            enter my conference room
          </a>
          <transition name="fade-in">
            <div v-if="participantsCount"
                 class="Home__waiting-count">
              <i class="icon-ic_warning"></i>
              <span>{{ participantsCount }} Participants Waiting in Your Conference Room</span>
            </div>
          </transition>
          <a @click="joinRoom"
            class="Home__main-action-btn Home__main-action-btn--green">
            join someone else's call
          </a>

          <a @click="startBroadcasting"
            v-if="showBroadcasting"
            class="Home__main-action-btn Home__main-action-btn--red">
            start broadcasting
          </a>
        </div>
      </div>
    </div>
    <join-room-modal/>
    <start-broadcasting-modal/>
    <page-title :title="'KingsConference - ' + user.username"></page-title>
  </div>
</template>

<script>
  import { REMOTE_PATHS } from '@/constants/remote-paths.constant';
  import PageTitle from '@/components/common/page-title/page-title';
  import UpgradeDropdown from '@/components/common/upgrade-dropdown/upgrade-dropdown';
  import JoinRoomModal from './join-room.modal/join-room.modal';
  import StartBroadcastingModal from './start-broadcasting.modal/start-broadcasting.modal';

  export default {
    name: 'home-tab',
    components: {
      JoinRoomModal,
      StartBroadcastingModal,
      PageTitle,
      UpgradeDropdown
    },
    data() {
      return {
        showUpgradeMenu: false,
        copyInfoClass: null
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      subscription() {
        return this.$store.getters.subscription;
      },
      participantsCount() {
        return this.$store.getters.participantsCount;
      },
      showBroadcasting() {
        if (!this.user.userId) return false;
        let showBroadcasting = true;
        const granted = REMOTE_PATHS.IDS_WITH_ACCESS_TO_HIDDEN_FEATURES;

        if (REMOTE_PATHS.BROADCAST_HIDDEN) {
          showBroadcasting = granted ? (granted.indexOf(this.user.userId) > -1) : false;
        }
        return showBroadcasting;
      }
    },
    methods: {
      joinOwnRoom() {
        this.$router.push({
          name: 'Room',
          params: {
            username: this.user.username,
            pin: this.user.conferencePin
          }
        });
      },
      joinRoom() {
        this.$modal.show('join-room-modal');
      },
      toggleUpgradeMenu() {
        this.showUpgradeMenu = !this.showUpgradeMenu;
      },
      setCopyInfoBtnClass(c, t) {
        setTimeout(() => {
          this.copyInfoClass = c;
        }, t);
      },
      startBroadcasting() {
        this.$modal.show('start-broadcasting-modal');
      },
      copyInfo() {
        this.setCopyInfoBtnClass('processing', 0);
        const temp = document.createElement('input');
        document.querySelector('.Home__header-actions').appendChild(temp);
        temp.value = this.user.conferenceUrl;
        temp.select();
        document.execCommand('copy');
        temp.remove();
        this.setCopyInfoBtnClass('termination', 500);
        this.setCopyInfoBtnClass(null, 1000);
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// home-tab.vue?6ef8d136